module.exports = __webpack_public_path__ + "static/media/download-solid-white.fae565e0.svg";